import React, { useState } from 'react'
import './groupedViewStyle.css'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import TableCellHeading from '../../Dashboard/PreviewComponent/components/TableCellHeading'
import RenderTableCells from '../../Dashboard/PreviewComponent/components/RenderTableCells'
import TableCellText from '../../Dashboard/PreviewComponent/components/TableCellText'
import { TableRow } from '@mui/material'
import { getColor } from '../../Dashboard/PreviewComponent/utils'

const GroupedViewInternal = ({
  data,
  headingMap = {},
  marginPerLevel = 10,
  heading = false,
  reviewData,
  previewCurrency,
}) => {
  const [isOpen, setIsOpen] = useState(data.is_open)

  const modifiedData = { f_key: data.key, f_value: data.name, ...data }

  const renderGroupBy = (value, isOpen, level = 0) => {
    if (isOpen) {
      return (
        <span
          style={{ marginLeft: level * marginPerLevel }}
          className="icon-with-text"
          onClick={() => setIsOpen(!isOpen)}
        >
          {value && <KeyboardArrowDownIcon />} {value}
        </span>
      )
    } else {
      return (
        <span
          style={{ marginLeft: level * marginPerLevel }}
          className="icon-with-text"
          onClick={() => setIsOpen(!isOpen)}
        >
          {value && <KeyboardArrowRightIcon />} {value}
        </span>
      )
    }
  }

  const getBorderColor = (level) => {
    switch (
      level % 6 // IT WILL REPEAT COLOR AFTER 6 LEVELS EVERY TIME
    ) {
      case 0:
        return '#FFB6B6'
      case 1:
        return '#FFCDA4'
      case 2:
        return '#FFF2B6'
      case 3:
        return '#B6FFBF'
      case 4:
        return '#DCDBFF'
      case 5:
        return '#F7C8FF'
      default:
        return '#FFFFFF'
    }
  }

  const renderCellBasedOnType = (cellObject) => {
    if (cellObject?.value || cellObject?.data_structure) {
      return (
        <RenderTableCells
          subField={cellObject}
          hiddenTableIds={[]}
          reviewData={reviewData}
          value={cellObject?.value}
          previewCurrency={previewCurrency}
        />
      )
    } else {
      return (
        <TableCellText
          color={getColor(reviewData, cellObject)}
          isHidden={false}
          value={cellObject}
        />
      )
    }
  }

  return (
    <>
      {heading && (
        <TableRow style={{ position: 'sticky', top: 0 }}>
          {Object.entries(headingMap).map(([key, value], index) => {
            return (
              key != 'children' && (
                <TableCellHeading>
                  {key === 'key' ? renderGroupBy(value, isOpen, data.level) : value}
                </TableCellHeading>
              )
            )
          })}
        </TableRow>
      )}

      <TableRow style={{ backgroundColor: getBorderColor(data.level) }}>
        {Object.keys(headingMap).map((it) => {
          return renderCellBasedOnType(
            it === 'f_key'
              ? renderGroupBy(
                  modifiedData[it]?.value || modifiedData[it],
                  isOpen,
                  modifiedData.level
                )
              : modifiedData[it]
          )
        })}
      </TableRow>
      {isOpen &&
        modifiedData.children &&
        modifiedData.children.length > 0 &&
        data.children.map((it, index) => {
          return (
            <GroupedViewInternal
              data={it}
              key={index}
              headingMap={headingMap}
              marginPerLevel={marginPerLevel}
              reviewData={reviewData}
              previewCurrency={previewCurrency}
            />
          )
        })}
    </>
  )
}

export default GroupedViewInternal
